import { environment } from '../../../environments/environment';
import {
  Component,
  Inject,
  PLATFORM_ID,
  ChangeDetectorRef,
  AfterViewInit,
  OnDestroy
} from '@angular/core';
import { isPlatformBrowser,isPlatformServer } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { CatalogService } from '../../modules/catalog/catalog.service';
import { CommonModule, DOCUMENT } from '@angular/common';
import { DataService } from './../../shared/services/data.service';
import { BasketService } from '../../modules/basket/basket.service';

@Component({
  selector: 'app-navbar',
  imports: [CommonModule],
  templateUrl: './navbar.html',
  styleUrl: './navbar.css',
})
export class Navbar implements AfterViewInit {
counter = '0';
  bsktUrl= "/";
  isMenuOpen = false;
    private intervalId: any;
  private isBrowser: boolean;
  constructor(private http: HttpClient,
  @Inject(PLATFORM_ID) private platformId: Object,private dataService: DataService,
  private cdr: ChangeDetectorRef,private basketService: BasketService,
  @Inject(DOCUMENT) private document: Document,private catalogService: CatalogService) {
  this.isBrowser = isPlatformBrowser(this.platformId);
}
ngAfterViewInit() {
  }
  toggleMenu() {
    this.isMenuOpen = !this.isMenuOpen;
  }
 ngOnInit() {
    if (isPlatformBrowser(this.platformId)) {
      var contactId = localStorage.getItem("contactId");
      var counter = localStorage.getItem("counter");
      
      if(contactId != undefined){
        this.checkValidityBasket(contactId);
        if (counter != '0' && counter != undefined) {
          this.counter = counter;
        }
      }
    }
  }
    checkValidityBasket(contactId:any){
    var publicKey:any ="";

    if (isPlatformBrowser(this.platformId)) {
      publicKey = localStorage.getItem('contactId');
    }
    
    if (publicKey == null) {
      publicKey="";
    } else {
      const isSSR = isPlatformServer(this.platformId);
      const apiUrl = isSSR
      ? `${environment.apiUrlLocal}`
      : `${environment.apiUrl}`;
      let url = `${apiUrl}/Basket/GetBasket?id=` + publicKey;
      
      this.dataService.get(url, publicKey).subscribe(
        data => {
          var basket = data.result;
          var bskt_createDate = new Date(basket.createDate);
          var currentDate = new Date();
          bskt_createDate.setDate(bskt_createDate.getDate() + 1);
          
          if (!basket?.createDate) return;
          
          if(bskt_createDate < currentDate){
            if (isPlatformBrowser(this.platformId)) {
              this.bsktUrl ="/";
              this.counter = "0";
              localStorage.clear();
            }
          } else {
            this.bsktUrl = '/panier/'+publicKey;
          }
          this.cdr.markForCheck();
        },
        errorResponse => {}
      );
    }
  }
}
